import React from "react"
import PropTypes from "prop-types"

const Products = ({ list }) => (
  <div className="products__container">
    {list.map((item) => (
      <div
        key={item.name}
        className={`product ${item.comingSoon ? "coming-soon" : ""}`}
      >
        {item.image ? (
          <img className="product__image" src={item.image} alt={item.name} />
        ) : null}
        <div className="product__name t5">{item.name}</div>
        {item.comingSoon ? (
          <div className="product__name t5">(Coming Soon)</div>
        ) : null}
        {item.price ? (
          <div className="product__price t5">{item.price}</div>
        ) : null}
      </div>
    ))}
  </div>
)

Products.propTypes = {
  list: PropTypes.instanceOf(Array).isRequired,
}

export default Products
